export enum APPLICATION_STAGE {
  PersonalDetails = 0,
  AddressDetails = 1,
  InstitutionDetails = 2,
  StudyDetails = 3,
  LegalGuardianDetails = 4,
  DocumentsUpload = 5,
  ApplicationSubmitted = 6,
  All = 7,
  ApplicationInReview = 9,
  ApplicationDeclined = 10,
  ApplicationSentForFurtherReview = 11,
  ApplicationFullyAssessedAndIsPendingUniversitySelection = 12,
  ApplicationSuccessful = 13,
  IncompleteApplication = 14,
  Assessed = 200,
  NotAssessed = 201
}

const numericStageValues = new Set(
  Object.values(APPLICATION_STAGE).filter(
    (v): v is number => typeof v === "number"
  )
);

/**
 * Admin list API returns `applicationStage` as the C# enum name (e.g. `"ApplicationSubmitted"`).
 * Other endpoints may use numeric values. Filters and comparisons should use this helper.
 */
export function normalizeApplicationStage(
  raw: APPLICATION_STAGE | string | number | undefined | null
): APPLICATION_STAGE | null {
  if (raw === undefined || raw === null) return null;
  if (typeof raw === "number" && numericStageValues.has(raw)) {
    return raw as APPLICATION_STAGE;
  }
  const asNum = Number(raw);
  if (!Number.isNaN(asNum) && numericStageValues.has(asNum)) {
    return asNum as APPLICATION_STAGE;
  }
  if (typeof raw === "string") {
    const byName = (APPLICATION_STAGE as unknown as Record<string, number>)[
      raw
    ];
    if (typeof byName === "number" && numericStageValues.has(byName)) {
      return byName as APPLICATION_STAGE;
    }
  }
  return null;
}
